import type { Transaction } from "@rocicorp/zero";
import type { Context } from "../authorization";
import type { Schema } from "../generatedDrizzleSchema";
import { hasAccess } from "./access";
import type { Permission } from "./permissions";
import { BUILTIN_ROLES } from "./roles";
import type { ResolvedGrantRole } from "./validation/grantResources";

export type ServiceAccountGrantDenial =
  | { reason: "allow_all" }
  | { reason: "missing_permission"; permission: Permission };

function conferredPermissions(role: ResolvedGrantRole): readonly Permission[] {
  if (role.builtinRoleId) {
    return BUILTIN_ROLES[role.builtinRoleId].permissions;
  }
  return role.customRole.rolePermissions.map(
    (rolePermission) => rolePermission.permission as Permission
  );
}

export async function checkServiceAccountGrant(opts: {
  tx: Transaction<Schema>;
  ctx: Context;
  scopeId: string;
  role: ResolvedGrantRole;
}): Promise<ServiceAccountGrantDenial | null> {
  for (const permission of conferredPermissions(opts.role)) {
    if (permission === "allow_all") return { reason: "allow_all" };
    const granterHas = await hasAccess({
      tx: opts.tx,
      userId: opts.ctx.userId,
      principal: opts.ctx.principal,
      scopeId: opts.scopeId,
      tenantId: opts.ctx.tenantId,
      permission,
    });
    if (!granterHas) {
      return { reason: "missing_permission", permission };
    }
  }
  return null;
}
